import React from "react";
import {FormGroup, Input, Label} from "reactstrap";
import {numberValidation} from "../../_utils/numberValidation";

const DynamicFormFloat = (props) => {
    const handleChange = (event) => {
        const {value} = event.target;

        props.handleChange(props.index, {id: props.id, value: value}, props.readingType);
    };

    return (
        <div>
            <Label>{props.title} {props.mandatory && "*"}</Label>
            <FormGroup className={props.validationStatus}>
                <Input type="text"
                       name={props.name}
                       onChange={(event) => numberValidation(event, handleChange, true)}
                       value={props.value}
                       onBlur={() => props.validateField(props.index, {id: props.id, type: props.readingType})}
                       maxLength={props.maxlength}/>
                {props.validationStatus === "has-danger" &&
                <label className="error">
                    Polje je obvezno
                </label>}
                {props.webLimits && props.webLimits.a && <Label>( zaloga vrednosti {props.webLimits.a.minValue} - {props.webLimits.a.maxValue} )</Label>}
            </FormGroup>
        </div>
    );
};

export default DynamicFormFloat;
